import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Users, Clock, Heart } from 'lucide-react';

interface AnalyticsData {
  totalVotes: number;
  totalTips: number;
  avgSessionTime: number; // minutes
  totalViewers: number;
}

export const AnalyticsCharts = ({ 
  totalVotes = 0, 
  totalTips = 0, 
  avgSessionTime = 0,
  totalViewers = 0 
}: Partial<AnalyticsData>) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <BarChart className="h-5 w-5" />
          Engagement Analytics
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-2">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Users className="h-4 w-4" />
              Total Viewers
            </div>
            <div className="text-2xl font-bold">{totalViewers.toLocaleString()}</div>
          </div>

          <div className="space-y-2">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Heart className="h-4 w-4" />
              Total Tips
            </div>
            <div className="text-2xl font-bold">{totalTips.toLocaleString()}</div>
          </div>

          <div className="space-y-2">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <BarChart className="h-4 w-4" />
              Poll Votes
            </div>
            <div className="text-2xl font-bold">{totalVotes.toLocaleString()}</div>
          </div>

          <div className="space-y-2">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Clock className="h-4 w-4" />
              Avg. Session
            </div>
            <div className="text-2xl font-bold">{avgSessionTime}m</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};